// Ohjelmiston versio. Näkyy asiakassovelluksen ja master-hallinnan alalaidassa,
// jotta tukikeskustelussa tiedetään mistä versiosta puhutaan.
export const VERSIO = '1.08';
